import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1764.98015,1402.82421 L1920.34165,1558.18571 L1558.52736,1920 L368.81429,1920 L7,1558.18571 L162.361496,1402.82421 L459.789763,1700.25248 L1467.55189,1700.25248 L1764.98015,1402.82421 Z M965.901262,0 L1483.07705,517.175787 L1327.71555,672.537283 L1075.77502,420.596752 L1075.77502,1423.30468 L856.027503,1423.30468 L856.027503,420.596752 L604.086972,672.537283 L448.725476,517.175787 L965.901262,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconUploadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconUploadSolid, _Component);

  var _super = _createSuper(IconUploadSolid);

  function IconUploadSolid() {
    _classCallCheck(this, IconUploadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconUploadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUpload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUploadSolid.displayName = "IconUploadSolid";
  return IconUploadSolid;
}(Component);

IconUploadSolid.glyphName = 'upload';
IconUploadSolid.variant = 'Solid';
IconUploadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUploadSolid;
export { IconUploadSolid };